import { Injectable } from "@angular/core";
import { MCAuthoritiesEventsAntiquities, MCCustomFunctionsParams } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsAntiquities extends MCAuthoritiesEventsAntiquities {

    override importPurposeListAntiquites(customFunctionsParams: MCCustomFunctionsParams) {
        throw new Error("Method not implemented.");
    }
}
